export const contentTypeFromFilename = (filename) => {
  const extension = filename.split('.').pop();
  if (extension === 'pdf') {
    return 'application/pdf';
  }
  if (extension === 'doc') {
    return 'application/msword';
  }
  if (extension === 'docx') {
    return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  }
  if (extension === 'xls') {
    return 'application/vnd.ms-excel';
  }
  if (extension === 'xlsx') {
    return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }
  if (extension === 'ppt') {
    return 'application/vnd.ms-powerpoint';
  }
  if (extension === 'pptx') {
    return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
  }
  if (extension === 'jpeg') {
    return 'image/jpeg';
  }
  if (extension === 'jpg') {
    return 'image/jpeg';
  }
  if (extension === 'gif') {
    return 'image/gif';
  }
  if (extension === 'png') {
    return 'image/png';
  }
  if (extension === 'apng') {
    return 'image/apng';
  }
  if (extension === 'svg') {
    return 'image/svg+xml';
  }
  if (extension === 'bmp') {
    return 'image/bmp';
  }
  return undefined;
};

export const fileIconFromExtension = (filename) => {
  const extension = filename.split('.').pop();
  if (extension === 'pdf') {
    return 'file-pdf';
  }
  if (extension === 'doc' || extension === 'docx') {
    return 'file-word';
  }
  if (extension === 'xls' || extension === 'xlsx') {
    return 'file-excel';
  }
  if (extension === 'ppt' || extension === 'pptx') {
    return 'file-powerpoint';
  }
  return 'file-unknown';
};

export const getDefaultContentTypeImage = contentType => {
  if (!contentType) {
    return '';
  }

  if (contentType.includes('application/pdf')) {
    return require('../assets/images/documentTypes/PdfIcon117x128.png');
  }

  if (contentType.includes('msword') || contentType.includes('wordprocessingml.document')) {
    return require('../assets/images/documentTypes/WordIcon256x256.png');
  }

  if (contentType.includes('ms-excel') || contentType.includes('spreadsheetml.sheet')) {
    return require('../assets/images/documentTypes/ExcelIcon256x256.png');
  }

  if (contentType.includes('ms-powerpoint') || contentType.includes('presentationml.presentation')) {
    return require('../assets/images/documentTypes/PowerPointIcon256x256.png');
  }

  return '';
};
